export const tableSx = {
  '.MuiDataGrid-cellCheckbox.MuiDataGrid-cell': {
    borderRight: 'none',
    outline: 'none',
  },
  '.MuiDataGrid-columnHeaderCheckbox': {
    borderRight: 'none',
  },
  '.MuiDataGrid-columnSeparator .MuiDataGrid-columnSeparator--sideRight': {
    display: 'none',
  },
  '.controls-cell.MuiDataGrid-cell:focus-within, .MuiDataGrid-columnHeader.MuiDataGrid-withBorderColor:focus-within': {
    outline: 'none',
  },
  '.MuiDataGrid-pinnedColumns--right ': {
    borderRight: 'none',
  },
  '.MuiDataGrid-columnHeader .MuiDataGrid-columnHeader': {
    '--go-table-border-right': 'none',
  },
  '.MuiDataGrid-detailPanelToggleCell': {
    width: '100%',
    height: '100%',
    padding: 0,
    color: 'var(--go-text)',
  },
};
